// extracted by mini-css-extract-plugin
export var active = "_2i-9";
export var backButton = "_2i-8";
export var clone = "_2i-e";
export var collapseBar = "_2i-k";
export var collapseMode = "_2i-m";
export var collapsed = "_2i-o";
export var dimmed = "_2i-i";
export var dragHandle = "_2i-c";
export var dropdownIcon = "_2i-g";
export var expanding = "_2i-n";
export var hidden = "_2i-x";
export var iconContainer = "_2i-q";
export var iconSwapper = "_2i-w";
export var navItem = "_2i-6";
export var navItemIcon = "_2i-f";
export var navProfile = "_2i-7";
export var notificationCountBadge = "_2i-j";
export var notificationDot = "_2i-r";
export var optionsContainer = "_2i-h";
export var primaryNav = "_2i-0";
export var primaryNavDivider = "_2i-v";
export var primaryNavResizeHandle = "_2i-2";
export var primaryNavResizing = "_2i-1";
export var primaryNavTabSection = "_2i-u";
export var primaryTab = "_2i-p";
export var primaryTabIconBox = "_2i-s";
export var secondaryNav = "_2i-3";
export var selected = "_2i-t";
export var settingsNav = "_2i-4";
export var settingsNavItems = "_2i-5";
export var show = "_2i-d";
export var sideNav = "_2i-l";
export var teamItem = "_2i-a";
export var userProfileItem = "_2i-b";